<template>
  <div>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xs"
      persistent
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-toolbar color="black">
          <v-toolbar-title style="color: white"
            >{{ editedIndex == -1 ? "CREATE" : "EDIT" }} ADS</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="closeDialog()" :disabled="isLoading">
              <v-icon color="white">close</v-icon>
            </v-btn>
            <!-- <v-btn icon flat @click="createCampaign()" :loading="isLoading">
              <v-icon large>save</v-icon>
            </v-btn> -->
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text
          style="max-height: 60vh; overflow: auto"
          v-if="!is_crop_image"
        >
          <div style="display: flex; justify-content: center">
            <div
              style="width: 200px; height: 113px; position: relative"
              v-if="imgURL != null || editedIndex > -1"
            >
              <img
                width="100%"
                height="100%"
                style="position: relative; z-index: 0"
                :src="imgURL"
                v-if="imgURL != null"
              />
              <img
                width="100%"
                height="100%"
                style="position: relative; z-index: 0"
                :src="form.ads_image"
                v-else
              />
              <div
                style="
                  top: 0px;
                  left: 0px;
                  position: absolute;
                  z-index: 1;
                  width: 100%;
                  height: 100%;
                  background-color: rgba(1, 1, 1, 0.3);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <v-btn icon color="white" @click="$refs.ImageInput.click()">
                  <v-icon>edit</v-icon></v-btn
                >
              </div>
            </div>
            <div
              style="
                width: 200px;
                height: 113px;
                background-color: #c9c9c9;
                display: flex;
                justify-content: center;
                align-items: center;
              "
              v-else
            >
              <v-btn icon color="white" @click="$refs.ImageInput.click()">
                <v-icon>add</v-icon></v-btn
              >
            </div>
            <input
              style="display: none"
              @change="onImageSelected"
              type="file"
              ref="ImageInput"
              accept=".jpeg,.jpg"
            />
          </div>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card class="pa-3" flat>
              <div
                class="mt-3"
                style="
                  padding: 10px 10px 20px 10px;
                  border: 1.5px solid #c9c9c9;
                  border-radius: 5px;
                "
              >
                <v-radio-group
                  hide-details
                  v-model="form.ads_action_type"
                  row
                  @change="selectActionType()"
                >
                  <v-radio
                    color="primary"
                    label="Hyper Link"
                    value="Hyper Link"
                  ></v-radio>
                  <v-radio
                    color="primary"
                    label="In app"
                    value="Food store in app"
                  ></v-radio>
                </v-radio-group>
                <v-text-field
                  v-if="form.ads_action_type == 'Hyper Link'"
                  label="Link"
                  v-model="form.ads_hyper_link"
                  :rules="[rules.required, rules.html]"
                ></v-text-field>
              </div>
              <div
                v-if="form.ads_action_type == 'Food store in app'"
                class="mt-3"
                style="
                  padding: 10px;
                  border: 1.5px solid #c9c9c9;
                  border-radius: 5px;
                "
              >
                <v-select
                  class="pr-2"
                  v-model="form.ads_province[0]"
                  :items="provinceData"
                  item-text="province_name_th"
                  item-value="province_id"
                  label="Select Province"
                  :rules="[rules.required]"
                  @change="getStoreData()"
                ></v-select>
                <v-autocomplete
                  :disabled="form.ads_province[0] == null"
                  class="pr-2"
                  v-model="form.ads_store_id"
                  :items="storeList"
                  item-text="store_name_th"
                  item-value="store_id"
                  label="Select Store"
                  clearable
                  :rules="[rules.required]"
                  :loading="isLoadingStore"
                ></v-autocomplete>
              </div>

              <div
                v-if="form.ads_action_type == 'Hyper Link'"
                class="mt-3"
                style="
                  padding: 10px;
                  border: 1.5px solid #c9c9c9;
                  border-radius: 5px;
                "
              >
                <v-radio-group
                  v-model="form.ads_is_all_province"
                  row
                  @change="getDistrictData()"
                >
                  <v-radio
                    color="primary"
                    label="All Province"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    color="primary"
                    label="Some Province"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
                <v-select
                  v-if="form.ads_is_all_province == false"
                  class="pr-2"
                  v-model="form.ads_province"
                  :items="provinceData"
                  attach
                  item-text="province_name_th"
                  item-value="province_id"
                  chips
                  label="Select Province"
                  multiple
                  clearable
                  :rules="[(v) => v.length > 0 || 'required']"
                  @change="getDistrictData()"
                ></v-select>
              </div>
              <!-- get_random?province=66  -->

              <div
                class="mt-3"
                style="
                  padding: 10px;
                  border: 1.5px solid #c9c9c9;
                  border-radius: 5px;
                "
                v-if="form.ads_action_type == 'Hyper Link'"
              >
                <v-radio-group
                  v-model="form.ads_is_all_district"
                  row
                  @change="
                    form.ads_district = [];
                    form.ads_store_id = null;
                  "
                >
                  <v-radio
                    color="primary"
                    label="All District"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    color="primary"
                    label="Some District"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
                <v-autocomplete
                  v-if="form.ads_is_all_district == false"
                  class="pr-2"
                  v-model="form.ads_district"
                  :items="districtList"
                  attach
                  item-text="district_name_th"
                  item-value="district_id"
                  chips
                  label="Select District"
                  multiple
                  clearable
                  :rules="[(v) => v.length > 0 || 'required']"
                ></v-autocomplete>
              </div>

              <div
                class="mt-3"
                style="
                  padding: 10px;
                  border: 1.5px solid #c9c9c9;
                  border-radius: 5px;
                "
              >
                <v-layout row wrap>
                  <v-flex xs12 sm6 class="pr-2">
                    <v-text-field
                      :rules="[rules.required]"
                      label="Title TH"
                      v-model="form.ads_title_th"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pr-2">
                    <v-text-field
                      label="Title EN"
                      v-model="form.ads_title_en"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6 class="pr-2">
                    <v-textarea
                      :rules="[rules.required]"
                      label="Description TH"
                      v-model="form.ads_description_th"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 sm6 class="pr-2">
                    <v-textarea
                      label="Description EN"
                      v-model="form.ads_description_en"
                      :rules="[rules.required]"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6 class="pr-2">
                    <v-text-field
                      :rules="[rules.required]"
                      label="Action name TH"
                      v-model="form.ads_action_name_th"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pr-2">
                    <v-text-field
                      :rules="[rules.required]"
                      label="Action name EN"
                      v-model="form.ads_action_name_en"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="pr-2">
                    <v-text-field
                      label="Supported by"
                      v-model="form.ads_support_by"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-text style="max-height: 60vh; overflow: auto" v-else>
          <imageCropper
            :aspectRatio="16 / 9"
            :imageName="image_name"
            :imgSrc="imageCrop"
            :height="300"
            @close="is_crop_image = false"
            @setImageName="image_name = $event"
            @getCroped="getCropped($event)"
            v-if="is_crop_image == true"
          ></imageCropper>
        </v-card-text>
        <v-divider v-if="!is_crop_image"></v-divider>
        <v-card-actions v-if="!is_crop_image">
          <v-spacer></v-spacer>
          <v-btn
            @click="closeDialog()"
            style="border-radius: 10px"
            class="white--text"
            color="red"
            :disabled="isLoading"
          >
            cancel</v-btn
          >
          <v-btn
            @click="submit()"
            style="border-radius: 10px"
            class="white--text"
            color="success"
            :loading="isLoading"
          >
            save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import imageCropper from "@/components/Plugins/imageCropper.vue";
export default {
  props: ["dialog", "editedIndex", "editedItem"],
  data() {
    return {
      is_crop_image: false,
      image_name: "",
      imgURL: null,
      imageCrop: null,
      valid: true,
      isLoading: false,
      rules: {
        requiredPrice: (value) => (value != "0" && !!value) || "Required.",
        required: (value) => !!value || "Required.",
        requiredLength: (value) => value.length > 0 || "Required.",
        maxCode: (v) => v.length <= 6 || "No more than 6 characters",
        html: (value) => {
          const pattern = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
          return pattern.test(value) || "Invalid";
        },
      },

      form: {
        ads_action_name: "",
        ads_action_type: "Hyper Link",
        ads_title: "",
        ads_description: "",
        ads_image: "",
        ads_district: [],
        ads_province: [],
        ads_is_all_province: true,
        ads_is_all_district: true,
        ads_support_by: "",
        ads_hyper_link: "",
        ads_store_id: null,
      },
      districtList: [],
      isLoading: false,
      valid: true,
      storeList: [],
      isLoadingStore: false,
    };
  },
  components: {
    imageCropper,
  },

  watch: {
    async dialog() {
      if (this.dialog == true) {
        if (this.editedIndex > -1) {
          let result = JSON.parse(JSON.stringify(this.editedItem));
          result.ads_province = this.editedItem.ads_province.map(
            (val) => val.province_id
          );
          if (result.ads_province.length == 0) {
            result.ads_is_all_province = true;
          } else {
            result.ads_is_all_province = false;
          }
          result.ads_district = this.editedItem.ads_district.map(
            (val) => val.district_id
          );
          if (result.ads_district.length == 0) {
            result.ads_is_all_district = true;
          } else {
            result.ads_is_all_district = false;
          }
          this.form = result;
          if (this.form.ads_action_type == "Food store in app") {
            await this.getStoreData();
          } else if (this.form.ads_action_type == "Hyper Link") {
            await this.getDistrictData();
          }
        }
      }
    },
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
      updateWeserveADS: "advertising/updateWeserveADS",
      createWeserveADS: "advertising/createWeserveADS",
      fetchStoreListCore: "fetchStoreBack/fetchStoreListCore",
      fetchDistrictListByMultipleProvinceID:
        "fetchProvinceBack/fetchDistrictListByMultipleProvinceID",
    }),
    onImageSelected(event) {
      let file = event.target.files[0];
      this.image_name = file.name;
      let reader = new FileReader();

      reader.addEventListener("load", () => {
        this.imageCrop = reader.result;
        this.is_crop_image = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    getCropped(image_value) {
      this.imgURL = image_value;
      this.image_name = "";
      this.imageCrop = null;
    },
    resetForm() {
      this.form = {
        ads_action_name: "",
        ads_action_type: "Hyper Link",
        ads_title: "",
        ads_description: "",
        ads_image: "",
        ads_district: [],
        ads_province: [],
        ads_is_all_province: true,
        ads_is_all_district: true,
        ads_support_by: "",
        ads_hyper_link: "",
        ads_store_id: null,
      };
      this.is_crop_image = false;
      this.imgURL = null;
      this.$refs.form.resetValidation();
    },
    closeDialog() {
      this.resetForm();
      this.imageSrc = "";
      this.$emit("onClosed");
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      if (this.editedIndex == -1 && this.imgURL == null) {
        return alert("กรุณาใส่รูปภาพ");
      }
      let body = JSON.parse(JSON.stringify(this.form));

      if (this.imgURL == null) {
        delete body.ads_image;
      } else {
        body.ads_image = this.imgURL;
      }
      let result;
      this.isLoading = true;
      if (this.editedIndex == -1) {
        result = await this.createWeserveADS(body);
      } else {
        result = await this.updateWeserveADS(body);
      }
      this.isLoading = false;
      if (result == false) return;
      this.closeDialog();
    },
    selectActionType() {
      if (this.form.ads_action_type == "Food store in app") {
        this.form.ads_province = [null];
        this.form.ads_is_all_district = true;
        this.form.ads_is_all_province = false;
      } else if (this.form.ads_action_type == "Hyper Link") {
        this.form.ads_province = [];
        this.form.ads_is_all_district = true;
        this.form.ads_is_all_province = true;
      }

      this.storeList = [];
      this.form.ads_district = [];
      this.form.ads_store_id = null;
      this.form.ads_hyper_link = "";
    },
    async getStoreData() {
      this.isLoadingStore = true;
      let province = this.provinceData.find(
        (val) => val.province_id == this.form.ads_province[0]
      );

      let province_name_en = province.province_name_en
        .replace(" ", "")
        .toLowerCase();

      this.storeList = await this.fetchStoreListCore(province_name_en);
      this.isLoadingStore = false;
    },
    async getDistrictData() {
      let configProvinceList = [];
      if (this.form.ads_is_all_province == true) {
        configProvinceList = this.provinceData.map((val) => val.province_id);
      } else {
        configProvinceList = this.form.ads_province;
      }
      this.districtList = await this.fetchDistrictListByMultipleProvinceID(
        configProvinceList
      );
    },
  },
};
</script>

<style scoped>
.loading-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.loading-item {
  animation: fade 2s infinite linear;
}
.loading-item-span {
  font-size: 28px;
}
</style>
